/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/88140-rocket-livetrade.json"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Avik Banerjee",
  title: "Hi, I'm Avik!",
  subTitle: emoji(    
    "I'm an aerospace engineer building software and intelligent systems for spacecraft. My work spans embedded flight software, mission modeling, optimization, and ML—turning complex aerospace problems into reliable, testable systems."
  ),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ABanerjee33",
  linkedin: "https://www.linkedin.com/in/avik-banerjee-aero/",
  gmail: "theawesomeguy675@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "REVOLUTIONIZE THE HUMAN CONDITION THROUGH TECHNOLOGY",
  skills: [
    emoji("📶 Use Python for signal processing experiments"),
    emoji("⏚ Utilize KiCAD for PCB design and Arduino for PCB testing"),
    emoji("🖧 Leverage parallel computing and optimization algorithms in MATLAB to analyze space technology"),
    emoji("🚀 Model complex systems using MagicDraw, OpenMBEE, version control, and REST API"),
    emoji("🤖 Use Tensorflow for ML & Computer Vision")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "computer-vision",
      fontAwesomeClassname: "fas fa-camera"
    },    
    {
      skillName: "raspberry-pi",
      fontAwesomeClassname: "fab fa-raspberry-pi"
    },  
    {
      skillName: "3D-CAD",
      fontAwesomeClassname: "fas fa-cube"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },    
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },    
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },    
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Georgia Institute of Technology",
      logo: require("./assets/images/GTVertical_TechGold.png"),
      subHeader: "MS Aerospace Engineeering",
      duration: "August 2024 - May 2025",
      desc: "Key Coursework",
      descBullets: [
        "Undergraduate Coursework: Aerospace Systems Engineering & Orbital Mechanics"
      ]
    },
    {
      schoolName: "Georgia Institute of Technology",
      logo: require("./assets/images/GTVertical_TechGold.png"),
      subHeader: "BS Aerospace Engineeering (GPA: 4.0/4.0)",
      duration: "August 2021 - May 2024",
      desc: "Key Coursework",
      descBullets: [
        "Undergraduate Coursework: Object-Oriented Programming, Computing for Engineers, Linear Algebra, Dynamics, Thermodynamics & Fluids, Engineering Graphics & Design",
        "Self Discovery: Data Structures & Algorithms, C++ Development, Scripting, SQL Essential Training"
      ]
    },

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Embedded Systems",
      action: "BUILD + TEST",
      description:
        "Prototype, integrate, and validate flight-adjacent hardware from sensor input through test data."
    },
    {
      Stack: "Simulation & Optimization",
      action: "MODEL + DECIDE",
      description:
        "Turn mission questions into parallelized models, trade studies, and engineering decisions."
    },
    {
      Stack: "CAD & Mechanical Design",
      action: "DESIGN + SHIP",
      description:
        "Move concepts from parametric CAD to DFM-aware parts, assemblies, and production drawings."
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "SpaceX",
      companylogo: require("./assets/images/spacex.jpg"),
      date: "Aug. 2025 – Present",
      desc: [
        "Writing satellite software, with a focus on embedded systems and the complete software development lifecycle."
      ]
    },
    {
      role: "Principal Investigator",
      company: "Skyfall Space",
      companylogo: require("./assets/images/skyfall-space-logo.svg"),
      date: "Sep. 2023 – Jul. 2025",
      desc: [
        "Led a NASA-funded space venture focused on active orbital-debris cleanup, spanning project leadership and software development."
      ]
    },
    {
      role: "Graduate Research Assistant",
      company: "Georgia Institute of Technology",
      companylogo: require("./assets/images/GTVertical_TechGold.png"),
      date: "Aug. 2024 – May 2025",
      desc: [
        "Developed embedded software for solid-state single-molecule sensing with the Electronic Life-Detection Instrument for Enceladus/Europa (ELIE) in the Planetary eXploration Lab."
      ]
    },
    {
      role: "Software Engineering Intern",
      company: "SpaceX",
      companylogo: require("./assets/images/spacex.jpg"),
      date: "May 2024 – Aug. 2024",
      desc: [
        "Built high-performance C++ software with hardware-in-the-loop testing, AWS S3, gRPC, Python, and rigorous unit testing." 
      ]
    },  
    {
      role: "RF Summer Research Intern",
      company: "MIT Lincoln Laboratory",
      companylogo: require("./assets/images/LLBetter.jpg"),
      date: "May 2023 – Aug. 2023",
      desc: [
        "Modeled radar backend systems with Python and MATLAB, then designed, assembled, and tested PCB hardware for component health monitoring."
      ]
    },    
    {
      role: "Undergraduate Research Assistant",
      company: "Georgia Institute of Technology",
      companylogo: require("./assets/images/GTVertical_TechGold.png"),
      date: "Dec. 2021 – May 2023",
      desc: [
        "Worked in the Aerospace Systems Design Laboratory on systems engineering, ML/AI anomaly detection, Python, and MagicDraw."
      ]
    },
    {
      role: "Summer Research Intern",
      company: "MIT Lincoln Laboratory",
      companylogo: require("./assets/images/LLBetter.jpg"),
      date: "June 2022 – Aug. 2022",
      desc: [
        "Built orbital-physics and optimization tools in MATLAB to support engineering systems analysis and mission trade studies."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Design Philosophy",
  subtitle: "I TAKE IDEAS FROM CONCEPTION & SKETCHES TO FINAL DESIGN USING DESIGN FOR MANUFACTURING (DFM) CONCEPTS",
  projects: [
    {
      image: require("./assets/images/Elephant1.png"),
      projectName: "EleRay: Creative Ideation Phase",
      projectDesc: "EleRay transforms the normal table into a majestic piece of home décor exhibiting the core concepts of creative ideation",
      footerLink: [
        {
          name: "View full portfolio",
          url: "https://drive.google.com/file/d/1gNkZ-iwq0rYgRDEQtGcvkmrI_NmmRkqz/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/Elephant2.png"),
      projectName: "EleRay: Rendered 3D CAD parts",
      projectDesc: "Transformed sketches & ideation into 3D parts assembled together",
      footerLink: [
        {
          name: "View full portfolio",
          url: "https://drive.google.com/file/d/1gNkZ-iwq0rYgRDEQtGcvkmrI_NmmRkqz/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/Elephant3.png"),
      projectName: "EleRay: Final Dimensioning & Assembly",
      projectDesc: "Developing working drawings, implementing geometric tolerances, and putting together final assembly",
      footerLink: [
        {
          name: "View full portfolio",
          url: "https://drive.google.com/file/d/1gNkZ-iwq0rYgRDEQtGcvkmrI_NmmRkqz/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "IEEE Technology Innovation",
      subtitle:
        "Recieved an  award from IEEE for my research that showed Innovation in the understanding or application of electrical engineering and related technologies.",
      image: require("./assets/images/IEEE.png"),
      imageAlt: "IEEE Logo",
      footerLink: [
        {
          name: "IEEE",
          url: "https://www.ieee.org/"
        }
      ]
    },
    {
      title: "Collins Aerospace Award",
      subtitle:
        "Recieved an award from Rockwell Collins for my project showing excellence in a discipline within the realm of work done at Rockwell Collins.",
      image: require("./assets/images/Collins-Aerospace-White.png"),
      imageAlt: "Collins Aerospace Logo",
      footerLink: [
        {
          name: "Collins Aerospace",
          url: "https://www.collinsaerospace.com/"
        }
      ]
    },
    {
      title: "The Dr. Bob Award for Disruptive Engineering",
      subtitle: "Awarded for exemplary out-of-the-box thinking during summer BWSI CubeSat challenge.",
      image: require("./assets/images/BWSICubeSat.jpg"),
      imageAlt: "BWSI Logo",
      footerLink: [
        {
          name: "MIT BWSI",
          url: "https://beaverworks.ll.mit.edu/CMS/bw/bwsi"
        }
      ]
    },     
    {
      title: "LinkedIn Skill Assessment Badges",
      subtitle: "Passed following assessments: MySQL, MATLAB, Python, Java, Git, AutoCAD, and Excel",
      image: require("./assets/images/Linkedin.png"),
      imageAlt: "Linkedin Logo",
      footerLink: [
        {
          name: "Linkedin",
          url: "https://www.linkedin.com/in/avik-banerjee-aero/details/skills/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "blog",
  subtitle:
    "I take ideas from concept to deployment impelmenting design",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Have an opportunity in mind or just want to say hi? Would love to talk!",
  email_address: "theawesomeguy675@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
